// Displays the current time in hours and minutes using local formatting.
// If the "time-zone" attribute is present, use it convert the time (must
// be in the Olson time zone format). Updates once every minute.

const ATTRIBUTES = "hour minute month time-zone time-zone-name weekday year".split(" ")

class CurrentTimeElement extends HTMLElement {
  connectedCallback() {
    this.options = {}
    for (const name of ATTRIBUTES) {
      if (this.hasAttribute(name)) {
        this.options[camelize(name)] = this.getAttribute(name)
      }
    }
    this.timer = setInterval(() => this.render(), 1000 * 60)
    this.render()
  }

  disconnectedCallback() {
    clearInterval(this.timer)
  }

  render() {
    this.textContent = new Date().toLocaleString(navigator.language, this.options)
  }
}

function camelize(string) {
  return string.replace(/-([a-z])/g, (_, char) => char.toUpperCase())
}

customElements.define("current-time", CurrentTimeElement)
